<template>
  <div class="card shadow"
       :class="type === 'dark' ? 'bg-default': ''">
    <div class="card-header border-0"
         :class="type === 'dark' ? 'bg-transparent': ''">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="mb-0" :class="type === 'dark' ? 'text-white': ''">
          </h3>
        </div>
      </div>
    </div>

    <div class="table-responsive">
      <base-table class="table align-items-center table-flush"
                  :class="type === 'dark' ? 'table-dark': ''"
                  :thead-classes="type === 'dark' ? 'thead-dark': 'thead-light'"
                  tbody-classes="list"
                  :data="staticContents">
        <template slot="columns">
          <th class="text-center">#</th>
          <th class="text-center">Contents</th>
          <th class="text-center">Last Update</th>
          <th class="text-center">Actions</th>
        </template>

        <template slot-scope="{row, index}">
          <td scope="row" class="text-center">
            <div class="media align-items-center">
              <div class="media-body">
                <span class="name mb-0 text-sm">{{index+1+(10*0)}}</span>
              </div>
            </div>
          </td>
          <td scope="row" class="text-center">
            <div class="media align-items-center">
              <div class="media-body">
                <span class="name mb-0 text-sm">{{row.name}}</span>
              </div>
            </div>
          </td>
          <td scope="row" class="text-center">
            <div class="media align-items-center">
              <div class="media-body">
                <span class="name mb-0 text-sm">{{row.updated_at}}</span>
              </div>
            </div>
          </td>

          <td class="text-center">
            <base-dropdown class="dropdown"
                           position="center">
              <a slot="title" class="btn btn-sm btn-icon-only text-light" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <i class="fas fa-ellipsis-v"></i>
              </a>

              <template>
                <a class="dropdown-item" v-if="row.id == 1" @click="openTermsConditionModal()">Update</a>
                <a class="dropdown-item" v-if="row.id == 2" @click="openPrivacyPolicyModal()">Update</a>
                <a class="dropdown-item" v-if="row.id == 3" @click="openContactUsModal()">Update</a>
                <a class="dropdown-item" v-if="row.id == 4" @click="openAboutUsModal()">Update</a>
                <a class="dropdown-item" v-if="row.id == 5" @click="openFaqModal()">Update</a>
              </template>
            </base-dropdown>
          </td>

        </template>

      </base-table>
    </div>

    <div class="row" id="div-terms-condition-modal">
        <div class="col-md-4">
            <modal :show.sync="modals.terms_condition_modal"
               body-classes="p-0"
               modal-classes="modal-dialog-centered modal-lg">
                <card type="secondary" shadow
                      header-classes="bg-white pb-4"
                      body-classes="px-lg-5 py-lg-5"
                      class="border-0">
                    <template>
                        <div slot="header" class="bg-white border-0">
                            <div class="row align-items-center">
                                <div class="col-8">
                                    <h3 class="mb-0">Terms & Conditions</h3>
                                </div>
                            </div>
                        </div>
                        <form @submit.prevent>
                            <div>
                                <div class="form-group row">
                                  <textarea class="form-control summernote" id="termsandcondition" ref="summernote"></textarea>
                                </div>
                                <div class="text-center">
                                    <base-button type="danger" class="my-4" @click="modals.terms_condition_modal = false">Cancel</base-button>
                                    <base-button type="success" class="my-4" @click="updateTermsAndCondition()">Update</base-button>
                                </div>
                            </div>
                        </form>
                    </template>
                </card>
            </modal>
        </div>
    </div>

    <div class="row" id="div-privacy-policy-modal">
        <div class="col-md-4">
            <modal :show.sync="modals.privacy_policy_modal"
               body-classes="p-0"
               modal-classes="modal-dialog-centered modal-lg">
                <card type="secondary" shadow
                      header-classes="bg-white pb-4"
                      body-classes="px-lg-5 py-lg-5"
                      class="border-0">
                    <template>
                        <div slot="header" class="bg-white border-0">
                            <div class="row align-items-center">
                                <div class="col-8">
                                    <h3 class="mb-0">Privacy Policy</h3>
                                </div>
                            </div>
                        </div>
                        <form @submit.prevent>
                            <div>
                                <div class="form-group row">
                                  <textarea class="form-control summernote" id="privacypolicy" ref="summernote"></textarea>
                                </div>
                                <div class="text-center">
                                    <base-button type="danger" class="my-4" @click="modals.privacy_policy_modal = false">Cancel</base-button>
                                    <base-button type="success" class="my-4" @click="updatePrivacyPolicy()">Update</base-button>
                                </div>
                            </div>
                        </form>
                    </template>
                </card>
            </modal>
        </div>
    </div>

    <div class="row" id="div-contact-us-modal">
        <div class="col-md-4">
            <modal :show.sync="modals.contact_us_modal"
               body-classes="p-0"
               modal-classes="modal-dialog-centered modal-lg">
                <card type="secondary" shadow
                      header-classes="bg-white pb-4"
                      body-classes="px-lg-5 py-lg-5"
                      class="border-0">
                    <template>
                        <div slot="header" class="bg-white border-0">
                            <div class="row align-items-center">
                                <div class="col-8">
                                    <h3 class="mb-0">Contact Us</h3>
                                </div>
                            </div>
                        </div>
                        <form @submit.prevent>
                            <div>
                                <div class="alert alert-danger text-left" v-if="show == true" v-html="message"></div>
                                <div class="form-group row">
                                  <div class="col-sm-3 col-form-label">Line 1: </div>
                                  <div class="col-sm-9">
                                    <base-input alternative=""
                                                placeholder="Line 1"
                                                input-classes="form-control-alternative"
                                                type="text"
                                                v-model="contactUs.line_1"
                                    />
                                  </div>
                                </div>
                                <div class="form-group row">
                                  <div class="col-sm-3 col-form-label">Line 2: </div>
                                  <div class="col-sm-9">
                                    <base-input alternative=""
                                                placeholder="Line 2"
                                                input-classes="form-control-alternative"
                                                type="text"
                                                v-model="contactUs.line_2"
                                    />
                                  </div>
                                </div>
                                <div class="form-group row">
                                  <div class="col-sm-3 col-form-label">Town: </div>
                                  <div class="col-sm-9">
                                    <base-input alternative=""
                                                placeholder="Town"
                                                input-classes="form-control-alternative"
                                                type="text"
                                                v-model="contactUs.city"
                                    />
                                  </div>
                                </div>
                                <div class="form-group row">
                                  <div class="col-sm-3 col-form-label">Postal Code: </div>
                                  <div class="col-sm-9">
                                    <base-input alternative=""
                                                placeholder="Postal Code"
                                                input-classes="form-control-alternative"
                                                type="text"
                                                v-model="contactUs.postcode"
                                    />
                                  </div>
                                </div>
                                <div class="form-group row">
                                  <div class="col-sm-3 col-form-label">Country: </div>
                                  <div class="col-sm-9">
                                     <select class="form-control" v-model="contactUs.country" v-on:change="getStates()">
                                       <option value=''>-- Select Country --</option>
                                       <template v-for="(data, key) in countries">
                                          <option v-bind:key="key" v-bind:value="data.country_id">{{ data.name }}</option>
                                      </template>
                                     </select>
                                  </div>
                                </div>
                                <div class="form-group row">
                                  <div class="col-sm-3 col-form-label">State: </div>
                                  <div class="col-sm-9">
                                     <select class="form-control" v-model="contactUs.state">
                                       <option value=''>-- Select State --</option>
                                       <template v-for="(data, key) in states">
                                          <option v-bind:key="key" v-bind:value="data.state_id">{{ data.name }}</option>
                                      </template>
                                       
                                     </select>
                                  </div>
                                </div>
                                <div class="form-group row">
                                  <div class="col-sm-3 col-form-label">Latitude: </div>
                                  <div class="col-sm-9">
                                    <base-input alternative=""
                                                placeholder="Latitude"
                                                input-classes="form-control-alternative"
                                                type="text"
                                                v-model="contactUs.latitude"
                                    />
                                  </div>
                                </div>
                                <div class="form-group row">
                                  <div class="col-sm-3 col-form-label">Longitude: </div>
                                  <div class="col-sm-9">
                                    <base-input alternative=""
                                                placeholder="Longitude"
                                                input-classes="form-control-alternative"
                                                type="text"
                                                v-model="contactUs.longitude"
                                    />
                                  </div>
                                </div>
                                <div class="form-group row">
                                  <div class="col-sm-3 col-form-label">Phone Number: </div>
                                  <div class="col-sm-9">
                                    <base-input alternative=""
                                                placeholder="Phone Number"
                                                input-classes="form-control-alternative"
                                                type="text"
                                                v-model="contactUs.phoneNumber"
                                    />
                                  </div>
                                </div>
                                <div class="form-group row">
                                  <div class="col-sm-3 col-form-label">Email Address: </div>
                                  <div class="col-sm-9">
                                    <base-input alternative=""
                                                placeholder="Email Address"
                                                input-classes="form-control-alternative"
                                                type="text"
                                                v-model="contactUs.emailAddress"
                                    />
                                  </div>
                                </div>
                                <div class="form-group row">
                                  <div class="col-sm-3 col-form-label">Feedback Email Address: </div>
                                  <div class="col-sm-9">
                                    <base-input alternative=""
                                                placeholder="Feedback Email Address"
                                                input-classes="form-control-alternative"
                                                type="text"
                                                v-model="contactUs.feedbackEmailAddress"
                                    />
                                  </div>
                                </div>
                                <div class="text-center">
                                    <base-button type="danger" class="my-4" @click="modals.contact_us_modal = false">Cancel</base-button>
                                    <base-button type="success" class="my-4" @click="updateContactUs()">Update</base-button>
                                </div>
                            </div>
                        </form>
                    </template>
                </card>
            </modal>
        </div>
    </div>

    <div class="row" id="div-about-us-modal">
        <div class="col-md-4">
            <modal :show.sync="modals.about_us_modal"
               body-classes="p-0"
               modal-classes="modal-dialog-centered modal-lg">
                <card type="secondary" shadow
                      header-classes="bg-white pb-4"
                      body-classes="px-lg-5 py-lg-5"
                      class="border-0">
                    <template>
                        <div slot="header" class="bg-white border-0">
                            <div class="row align-items-center">
                                <div class="col-8">
                                    <h3 class="mb-0">About Us</h3>
                                </div>
                            </div>
                        </div>
                        <form @submit.prevent>
                            <div>
                                <div class="alert alert-danger text-left" v-if="show == true" v-html="message"></div>
                                <div class="form-group row">
                                  <label class="col-sm-3 col-form-label">Image: </label> 
                                  <div class="col-sm-9">
                                    <!-- <base-input alternative=""
                                                placeholder="Credit"
                                                input-classes="form-control-alternative"
                                                type="number"
                                    /> -->
                                    <!-- <div class="input-group">
                                      <div class="input-group-prepend">
                                        <span class="input-group-text" id="inputGroupFileAddon01">Upload</span>
                                      </div>
                                      <div class="custom-file">
                                        <input type="file" class="custom-file-input" id="inputGroupFile01"
                                          aria-describedby="inputGroupFileAddon01" refs="file" @change="aboutUsFileUpload($event)">
                                        <label class="custom-file-label" for="inputGroupFile01">{{ aboutUs.fileName }}</label>
                                      </div>
                                    </div> -->
                                    <div class="custom-file-container" data-upload-id="imageUpload">
                                        <label><a href="javascript:void(0)" class="custom-file-container__image-clear" title="Clear Image"></a></label>
                                        <label class="custom-file-container__custom-file">
                                            <input type="file" class="custom-file-container__custom-file__custom-file-input" accept="*" aria-label="Choose File" @change="aboutUsFileUpload($event)">
                                            <input type="hidden" name="MAX_FILE_SIZE" value="10485760" />
                                            <span class="custom-file-container__custom-file__custom-file-control custom-file-label"></span>
                                        </label>
                                        <div class="custom-file-container__image-preview"></div>
                                    </div>
                                  </div>
                                </div>
                                <div class="form-group row">
                                  <label class="col-sm-3 col-form-label">Html: </label> 
                                  <div class="col-sm-9">
                                    <textarea class="form-control summernote" id="aboutus" ref="summernote" v-model="aboutUs.html"></textarea>
                                  </div>
                                </div>
                                <div class="text-center">
                                    <base-button type="danger" class="my-4" @click="modals.about_us_modal = false">Cancel</base-button>
                                    <base-button type="success" class="my-4" @click="updateAboutUs()">Update</base-button>
                                </div>
                            </div>
                        </form>
                    </template>
                </card>
            </modal>
        </div>
    </div>

    <div class="row" id="div-faq-modal">
      <div class="col-md-4">
            <modal :show.sync="modals.faq_modal"
               body-classes="p-0"
               modal-classes="modal-dialog-centered modal-xl">
                <card type="secondary" shadow
                      header-classes="bg-white pb-4"
                      body-classes="px-lg-5 py-lg-5"
                      class="border-0">
                    <template>
                        <div slot="header" class="bg-white border-0">
                            <div class="row align-items-center">
                                <div class="col-8">
                                    <h3 class="mb-0">Faq</h3>
                                </div>
                            </div>
                        </div>
                        <div class="card shadow"
                             :class="type === 'dark' ? 'bg-default': ''">
                          <div class="card-header border-0"
                               :class="type === 'dark' ? 'bg-transparent': ''">
                            <div class="row align-items-center">
                              <div class="col">
                                <h3 class="mb-0" :class="type === 'dark' ? 'text-white': ''">
                                </h3>
                              </div>
                              <div class="col text-right">
                                <base-button type="primary" size="md" @click="openCreateFaqModal()">Create New</base-button>
                              </div>
                            </div>
                          </div>

                          <div class="table-responsive">
                            <base-table class="table align-items-center table-flush"
                                        :class="type === 'dark' ? 'table-dark': ''"
                                        :thead-classes="type === 'dark' ? 'thead-dark': 'thead-light'"
                                        tbody-classes="list"
                                        :data="candidateFaqs">
                              <template slot="columns">
                                <th class="text-center">#</th>
                                <th class="text-center">Questions</th>
                                <th class="text-center">Actions</th>
                              </template>

                              <template slot-scope="{row, index}">
                                <td scope="row" class="text-center">
                                  <div class="media align-items-center">
                                    <div class="media-body">
                                      <span class="name mb-0 text-sm">{{index+1+(10*0)}}</span>
                                    </div>
                                  </div>
                                </td>
                                <td scope="row" class="text-center">
                                  <div class="media align-items-center">
                                    <div class="media-body">
                                      <span class="name mb-0 text-sm">{{row.question}}</span>
                                    </div>
                                  </div>
                                </td>

                                <td class="text-center">
                                  <base-dropdown class="dropdown"
                                                 position="center">
                                    <a slot="title" class="btn btn-sm btn-icon-only text-light" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                      <i class="fas fa-ellipsis-v"></i>
                                    </a>

                                    <template>
                                      <a class="dropdown-item" @click="openUpdateFaqModal(row.faq_id)">Update</a>
                                      <a class="dropdown-item" @click="openDeleteFaqModal(row.faq_id)">Delete</a>
                                    </template>
                                  </base-dropdown>
                                </td>

                              </template>

                            </base-table>
                          </div>

                          <div class="card-footer d-flex justify-content-end"
                               :class="type === 'dark' ? 'bg-transparent': ''">
                            <base-pagination :perPage="10" :total="10" :value="1"></base-pagination>
                          </div>

                        </div>

                        <div class="text-center">
                            <base-button type="danger" class="my-4" @click="modals.faq_modal = false">Cancel</base-button>
                        </div>
                    </template>
                </card>
            </modal>
        </div>
    </div>

    <div class="row" id="div-update-faq-modal">
        <div class="col-md-4">
            <modal :show.sync="modals.update_faq_modal"
               body-classes="p-0"
               modal-classes="modal-dialog-centered modal-lg">
                <card type="secondary" shadow
                      header-classes="bg-white pb-4"
                      body-classes="px-lg-5 py-lg-5"
                      class="border-0">
                    <template>
                        <div slot="header" class="bg-white border-0">
                            <div class="row align-items-center">
                                <div class="col-8">
                                    <h3 class="mb-0" v-if="faq.action == 1">UPDATE FAQ</h3>
                                    <h3 class="mb-0" v-if="faq.action == 2">CREATE FAQ</h3>
                                </div>
                            </div>
                        </div>
                        <form @submit.prevent>
                            <div>
                                <div class="alert alert-danger text-left" v-if="show == true" v-html="message"></div>
                                <div class="form-group row">
                                  <label class="col-sm-3 col-form-label">Question: </label> 
                                  <div class="col-sm-9">
                                    <textarea class="form-control" rows="3" placeholder="Question" v-model="faq.question"></textarea>
                                  </div>
                                </div>
                                <div class="form-group row">
                                  <label class="col-sm-3 col-form-label">Answer: </label> 
                                  <div class="col-sm-9">
                                    <textarea class="form-control" rows="3" placeholder="Answer" v-model="faq.answer"></textarea>
                                  </div>
                                </div>
                                <div class="text-center">
                                    <base-button type="danger" class="my-4" @click="modals.update_faq_modal = false; modals.faq_modal = true">Back</base-button>
                                    <base-button type="success" class="my-4" v-if="faq.action == 1" @click="updateFaq()">Update</base-button>
                                    <base-button type="success" class="my-4" v-if="faq.action == 2" @click="createFaq()">Create</base-button>
                                </div>
                            </div>
                        </form>
                        
                    </template>
                </card>
            </modal>
        </div>
    </div>

    <div class="row" id="div-confirmation-modal">
       <modal :show.sync="modals.confirmation_modal">
         <template slot="header">
            <h5 class="modal-title" id="exampleModalLabel">Delete</h5>
         </template>
         <div>
          Are you sure?
         </div>
         <template slot="footer">
             <base-button type="secondary" @click="">Close</base-button>
             <base-button type="primary" @click="deleteFaq(faq.faq_id)">Yes</base-button>
         </template>
       </modal>

    </div>

  </div>
</template>
<script>
  import FileUploadWithPreview from 'file-upload-with-preview';
  import 'file-upload-with-preview/dist/file-upload-with-preview.min.css';

  export default {
    name: 'candidate-static-contents-table',
    props: {
      type: {
        type: String
      },
      title: String
    },
    data() {
      return {
        totalStaticContent: 0,
        newIndustry: {
          title: ''
        },
        show: false,
        message: '',
        modals: {
          terms_condition_modal: false,
          privacy_policy_modal: false,
          contact_us_modal: false,
          about_us_modal: false,
          faq_modal: false,
          update_faq_modal: false,
          confirmation_modal: false
        },
        termsAndCondition: {
          html: ''
        },
        privacyPolicy: {
          html: ''
        },
        contactUs: {
          line_1: '',
          line_2: '',
          postcode: '',
          city: '',
          state: '',
          country: '',
          longitude: '',
          latitude: '',
          phoneNumber: '',
          emailAddress: '',
          feedbackEmailAddress: ''
        },
        aboutUs: {
          banner: '',
          html: '',
          fileName: '',
          file: ''
        },
        faq: {
          action: 0,
          faq_id: 0,
          question: '',
          answer: ''
        }
      }
    },
    computed: {
      staticContents()
      {
        return this.$store.getters.candidateStaticContents;
      },
      countries()
      {
        return this.$store.getters.countries;
      },
      states()
      {
        return this.$store.getters.states;
      },
      candidateFaqs()
      {
        return this.$store.getters.candidateFaqs;
      }
    },
    mounted() {
      this.getStaticContents();
      this.getTermsAndCondition();
      this.getPrivacyPolicy();
      this.getContactUs();
      this.getCountries();
      this.getStates();
      this.getAboutUs();
    },
    methods: {
      getCountries()
      {
        this.$store.dispatch('fetchCountries').then (response => {
          this.$store.dispatch('updateState', {
              key : 'countries',
              value : response.data
          });
        });
      },

      getStates : function () {
        this.$store.dispatch('fetchStates', {
          country_id : this.contactUs.country
        }).then (response => {
          this.$store.dispatch('updateState', {
              key : 'states',
              value : response.data
          });
        });
      },

      getStaticContents : function (page_number) {
        this.$store.dispatch('fetchCandidatesStaticContent').then (response => {
          this.$store.dispatch('updateState', {
              key : 'candidateStaticContents',
              value : response.data
          });
        });
      },

      openTermsConditionModal()
      {
        this.show = false;
        this.message = '';
        this.modals.terms_condition_modal = true;
        $('#termsandcondition').summernote({
          tabsize: 2,
          height: 200
        });
        $('.note-editable').html(this.termsAndCondition.html);
        
      },

      getTermsAndCondition()
      {
        this.$store.dispatch('fetchCandidatesTermsAndCondition').then (response => {
          this.termsAndCondition.html = response.data;
        });
      },

      openPrivacyPolicyModal()
      {
        this.show = false;
        this.message = '';
        this.modals.privacy_policy_modal = true;
        $('#privacypolicy').summernote({
          tabsize: 2,
          height: 200
        });
        $('.note-editable').html(this.privacyPolicy.html);
      },

      getPrivacyPolicy()
      {
        this.$store.dispatch('fetchCandidatesPrivacyPolicy').then (response => {
          this.privacyPolicy.html = response.data;
        });
      },

      openContactUsModal()
      {
        this.show = false;
        this.message = '';
        this.modals.contact_us_modal = true;
      },

      getContactUs()
      {
        this.$store.dispatch('fetchCandidatesContactUs').then (response => {
          this.contactUs.line_1 = response.data.line_1;
          this.contactUs.line_2 = response.data.line_2;
          this.contactUs.postcode = response.data.postcode;
          this.contactUs.city = response.data.city;
          this.contactUs.state = response.data.state;
          this.contactUs.country = response.data.country;
          this.contactUs.longitude = response.data.longitude;
          this.contactUs.latitude = response.data.latitude;
          this.contactUs.phoneNumber = response.data.phone_number;
          this.contactUs.emailAddress = response.data.email_address;
          this.contactUs.feedbackEmailAddress = response.data.feedback_email_address;
        });
      },

      openAboutUsModal()
      {
        this.show = false;
        this.message = '';
        this.modals.about_us_modal = true;
        $('#aboutus').summernote({
          tabsize: 2,
          height: 200
        });
        $('.note-editable').html(this.aboutUs.html);

        if (this.aboutUs.file === '') {
          var upload = new FileUploadWithPreview('imageUpload');
        } else {
          var upload = new FileUploadWithPreview('imageUpload', {
            presetFiles: [
              this.aboutUs.file
            ]
          });
        }
      },

      getAboutUs()
      {
        this.$store.dispatch('fetchCandidatesAboutUs').then (response => {
          this.aboutUs.fileName = response.data.banner;
          this.aboutUs.banner = response.data.banner;
          this.aboutUs.html = response.data.description_html;
          this.aboutUs.file = response.data.banner_url;
        });
      },

      aboutUsFileUpload (event)
      {
        let formData = new FormData();
        formData.append('banner', event.target.files[0]);

        this.$store.dispatch('uploadCandidatesAboutUsBanner', formData).then (response => {
          this.aboutUs.banner = response.data;
          this.aboutUs.fileName = response.data;
        });
      },

      updateAboutUs()
      {
        this.$store.dispatch('updateCandidatesAboutUs', {
          about_us_id: "1",
          banner: this.aboutUs.banner,
          html: $('#aboutus').summernote('code')
        }).then (response => {
          if (response.data.error == "1000") {
            this.modals.about_us_modal = false;
            this.getAboutUs();
          }  else if (response.data.error == "9999") {
            this.message = response.data.message;
            this.show = true;
          }
        });
      },

      updateTermsAndCondition()
      {
        this.$store.dispatch('updateCandidatesTermsAndCondition', {
          html: $('#termsandcondition').summernote('code')
        }).then (response => {
          if (response.data.error == "1000") {
            this.modals.terms_condition_modal = false;
            this.getTermsAndCondition();
          }  else if (response.data.error == "9999") {
            this.message = response.data.message;
            this.show = true;
          }
        });
      },

      updatePrivacyPolicy()
      {
        this.$store.dispatch('updateCandidatesPrivacyPolicy', {
          html: $('#privacypolicy').summernote('code')
        }).then (response => {
          if (response.data.error == "1000") {
            this.modals.privacy_policy_modal = false;
            this.getPrivacyPolicy();
          }  else if (response.data.error == "9999") {
            this.message = response.data.message;
            this.show = true;
          }
        });
      },

      updateContactUs()
      {
        this.$store.dispatch('updateCandidatesContactUs', {
          contact_us_id: 1,
          line_1: this.contactUs.line_1,
          line_2: this.contactUs.line_2,
          postcode: this.contactUs.postcode,
          city: this.contactUs.city,
          state: this.contactUs.state,
          country: this.contactUs.country,
          longitude: this.contactUs.longitude,
          latitude: this.contactUs.latitude,
          phone_number: this.contactUs.phoneNumber,
          email_address: this.contactUs.emailAddress,
          feedback_email_address: this.contactUs.feedbackEmailAddress
        }).then (response => {
          if (response.data.error == "1000") {
            this.modals.contact_us_modal = false;
            this.getContactUs();
          }  else if (response.data.error == "9999") {
            this.message = response.data.message;
            this.show = true;
          }
        });
      },

      getFaqs()
      {
        this.$store.dispatch('fetchCandidatesFaqs').then (response => {
          this.$store.dispatch('updateState', {
              key : 'candidateFaqs',
              value : response.data
          });
        });
      },

      openFaqModal()
      {
        this.modals.faq_modal = true;
        this.getFaqs();
      },

      openUpdateFaqModal(faq_id)
      {
        this.show = false;
        this.message = '';
        this.modals.faq_modal = false;
        this.modals.update_faq_modal = true;
        this.faq.action = 1;
        this.$store.dispatch('fetchCandidatesFaq', {
          id: faq_id
        }).then (response => {
          this.faq.faq_id = faq_id;
          this.faq.question = response.data.question;
          this.faq.answer = response.data.answer;
        });
      },

      openCreateFaqModal()
      {
        this.show = false;
        this.message = '';
        this.modals.faq_modal = false;
        this.modals.update_faq_modal = true;
        this.faq.action = 2;
        this.faq.faq_id = 0;
        this.faq.question = '';
        this.faq.answer = '';
      },

      createFaq()
      {
        this.$store.dispatch('createCandidatesFaq', {
          question: this.faq.question,
          answer: this.faq.answer
        }).then (response => {
          if (response.data.error == "1000") {
            this.modals.update_faq_modal = false;
            this.modals.faq_modal = true;
            this.getFaqs();
          }  else if (response.data.error == "9999") {
            this.message = response.data.message;
            this.show = true;
          }
        });
      },

      updateFaq()
      {
        this.$store.dispatch('updateCandidatesFaq', {
          id: this.faq.faq_id,
          question: this.faq.question,
          answer: this.faq.answer
        }).then (response => {
          if (response.data.error == "1000") {
            this.modals.update_faq_modal = false;
            this.modals.faq_modal = true;
            this.getFaqs();
          }  else if (response.data.error == "9999") {
            this.message = response.data.message;
            this.show = true;
          }
        });
      },

      deleteFaq()
      {
        this.$store.dispatch('deleteCandidatesFaq', {
          id: this.faq.faq_id
        }).then (response => {
          if (response.data.code == "1000") {
            this.modals.update_faq_modal = false;
            this.modals.confirmation_modal = false;
            this.modals.faq_modal = true;
            this.getFaqs();
          }
        });
      },

      openDeleteFaqModal(faq_id)
      {
        this.faq.faq_id = faq_id;
        this.modals.faq_modal = false;
        this.modals.confirmation_modal = true;
      }
    }
  }
</script>
<style>
.custom-file-label {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.modal { overflow: auto !important; }

.custom-file-container__custom-file__custom-file-control {
  color: #8898aa;
  border-color: #cad1d7;
}

.custom-file-container__custom-file__custom-file-control__button {
  color: #8898aa;
}

p {
  font-weight: normal !important;
}
</style>
